import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";
import { SowChangeBlockedProjectRequestSchema } from "@remi/types/sow-change/blocked-project";
import { requestSowChangeInputSchema } from "@remi/types/sowChangeType";

// The reviewer's edited request lives under `request`, not `payload`: on attempt data `payload` carries the
// attempt's own `attemptType`, and readers type it structurally on that convention.
export const SowChangeReviewTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SOW_CHANGE_REVIEW),
  attemptType: z.literal("CONFIRM"),
  blockedProjects: z.array(SowChangeBlockedProjectRequestSchema).optional(),
  request: requestSowChangeInputSchema.optional(),
});
